import { ArrowRightIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'

interface FeatureEntry {
  title: string
  description: string
  href: string
  status: 'planned' | 'in-progress' | 'done'
}

const FEATURES: FeatureEntry[] = [
  {
    title: 'New Payment System',
    description:
      'PromptPay QR via Beam API — orders, transactions, webhook reconciliation, and admin manual override.',
    href: '/admin/features/new-payment-system-plan',
    status: 'planned',
  },
]

const STATUS_STYLES: Record<FeatureEntry['status'], string> = {
  planned: 'bg-yellow-100 text-yellow-800',
  'in-progress': 'bg-blue-100 text-blue-800',
  done: 'bg-green-100 text-green-800',
}

const STATUS_LABELS: Record<FeatureEntry['status'], string> = {
  planned: 'Planned',
  'in-progress': 'In Progress',
  done: 'Done',
}

export default function PlannedFeaturesPage(): React.ReactElement {
  return (
    <div className="mx-auto max-w-3xl px-4 py-10">
      <h1 className="mb-1 font-bold text-2xl text-gray-900">
        Planned Features
      </h1>
      <p className="mb-8 text-gray-500 text-sm">
        Design documents and implementation plans for upcoming features.
      </p>

      <ul className="space-y-3">
        {FEATURES.map((f) => (
          <li key={f.href}>
            <Link
              to={f.href}
              className="group flex items-center justify-between rounded-lg border border-gray-200 bg-white px-5 py-4 shadow-sm transition hover:border-blue-400 hover:shadow-md"
            >
              <div className="min-w-0 flex-1">
                <div className="mb-1 flex items-center gap-2">
                  <span className="font-medium text-gray-900">{f.title}</span>
                  <span
                    className={`rounded-full px-2 py-0.5 font-medium text-xs ${STATUS_STYLES[f.status]}`}
                  >
                    {STATUS_LABELS[f.status]}
                  </span>
                </div>
                <p className="truncate text-gray-500 text-sm">
                  {f.description}
                </p>
              </div>
              <ArrowRightIcon className="ml-4 h-4 w-4 shrink-0 text-gray-400 transition group-hover:text-blue-500" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
